import { render, staticRenderFns } from "./TabsProposalsEdit.vue?vue&type=template&id=0d2e1518&"
import script from "./TabsProposalsEdit.vue?vue&type=script&lang=js&"
export * from "./TabsProposalsEdit.vue?vue&type=script&lang=js&"
import style0 from "./TabsProposalsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports